import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";
import { ThemaCodeType } from "reedy-data/api";

export const useThemaCodesQuery = (
  codeType: ThemaCodeType,
  language?: string,
  parentCode?: string,
  enabled = true,
) => {
  const api = useApi();

  return useQuery({
    queryKey: ["thema-codes", codeType, parentCode ?? "root", language],
    queryFn: async () => {
      return api.thema.getCodes({
        type: codeType,
        parent: parentCode,
        language,
      });
    },
    enabled,
    staleTime: 1000 * 60 * 60 * 24,
  });
};
